import React from "react";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

import CustomTooltip from "../components/CustomTooltip";

const COLORS = [
  "#4F46E5",
  "#10B981",
  "#F59E0B",
  "#EF4444",
  "#3B82F6",
  "#8B5CF6",
];

const ReportChart = ({
  data,
  grandTotal = 0,
  useBeforeVat,
  setUseBeforeVat,
}) => {
  if (!data || data.length === 0) {
    return (
      <p className="text-gray-500 dark:text-gray-400 text-center py-6">
        ไม่มีข้อมูลสรุปรายงาน
      </p>
    );
  }

  const theme = localStorage.getItem("theme");
  const isDarkMode = theme === "dark";
  const isMobile = window.innerWidth < 768;

  // คำนวณเปอร์เซ็นต์รวม
  const total = data.reduce((sum, item) => sum + item.totalSpending, 0);

  return (
    <div
      className="w-full rounded-lg p-4 transition-all duration-300"
      style={{ backgroundColor: "transparent" }}
    >
      {/* ⭐ Header Section (Total + Checkbox) */}
      <div
        className="
        w-full 
        flex flex-col md:flex-row 
        items-center 
        md:items-center 
        justify-center md:justify-between 
        mb-4
      "
      >
        {/* Total Summary */}
        <h3 className="text-lg font-bold text-gray-800 dark:text-gray-200 text-center md:text-left">
          ยอดรวมทั้งหมด:{" "}
          {grandTotal.toLocaleString("th-TH", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}{" "}
          บาท
        </h3>

        {/* Checkbox Minimal */}
        <label
          className="
          flex items-center space-x-2 cursor-pointer 
          mt-2 md:mt-0
          text-gray-700 dark:text-gray-300
          text-sm
        "
        >
          <input
            type="checkbox"
            checked={useBeforeVat}
            onChange={(e) => setUseBeforeVat(e.target.checked)}
            className="w-4 h-4 rounded accent-indigo-500 dark:accent-indigo-400 cursor-pointer"
          />
          <span>ใช้ยอดก่อน VAT</span>
        </label>
      </div>

      {/* 📊 Pie Chart */}
      <div className="flex justify-center items-center">
        <ResponsiveContainer
          width="100%"
          height={isMobile ? 260 : 320}
          style={{ backgroundColor: "transparent" }}
        >
          <PieChart>
            <Pie
              data={data}
              dataKey="totalSpending"
              nameKey="department"
              cx="50%"
              cy="50%"
              innerRadius={isMobile ? 50 : 55}
              outerRadius={isMobile ? 80 : 105}
              fill="#8884d8"
              labelLine={!isMobile}
              label={
                !isMobile
                  ? ({ department, totalSpending }) => {
                      const percent = ((totalSpending / total) * 100).toFixed(
                        1
                      );
                      return `${department}: ${totalSpending.toLocaleString(
                        "th-TH"
                      )} (${percent}%)`;
                    }
                  : false
              }
            >
              {data.map((_, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={COLORS[index % COLORS.length]}
                />
              ))}
            </Pie>

            {/* Tooltip */}
            <Tooltip content={<CustomTooltip isDarkMode={isDarkMode} />} />

            {/* Legend */}
            <Legend
              verticalAlign="bottom"
              align="center"
              wrapperStyle={{ paddingTop: "10px" }}
            />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default ReportChart;
